import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Observable, of, catchError, map, startWith } from 'rxjs'
import {
  ActiveSessionCountService,
  ActiveSessionCountResponse,
} from '../../services/roleplay/active-session-count.service'

interface ViewState {
  loading: boolean
  count: number | null
  error: boolean
}

/** アクティブセッション数を表示する standalone コンポーネント */
@Component({
  selector: 'app-active-session-count',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './active-session-count.component.html',
  styleUrls: ['./active-session-count.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveSessionCountComponent implements OnInit {
  state$!: Observable<ViewState>

  constructor(
    private readonly activeSessionCountService: ActiveSessionCountService,
  ) {}

  ngOnInit(): void {
    this.state$ = this.activeSessionCountService.getActiveSessionCount().pipe(
      map(
        (response: ActiveSessionCountResponse): ViewState => ({
          loading: false,
          count: response.activeSessionCount,
          error: false,
        }),
      ),
      catchError(() =>
        of<ViewState>({ loading: false, count: null, error: true }),
      ),
      startWith<ViewState>({ loading: true, count: null, error: false }),
    )
  }
}
